import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_PAYMENTISSUE_REQUEST,
  fetchIssuesFailure,
  fetchIssuesSuccess,
  SEARCH_PAYMENTISSUE_REQUEST,
  searchPaymentIssueSuccess,
  searchPaymentIssueFailure
} from "./paymentIssuesAction";
import SDK from "../../config";

function* fetchPaymentIssues(action) {
  const { page, limit } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/payment/issue/survey?page=${page}&limit=${limit}`);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = yield response.json();
    yield put(fetchIssuesSuccess(data.data));
  } catch (error) {
    console.error("Error fetching data:", error);
    yield put(fetchIssuesFailure(error.toString()));
  }
}

// Search Payment Issue data saga
function* searchPaumentIssue(action) {
  const { searchTerm } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/search/payment/issue?searchTerm=${searchTerm}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = yield response.json();
    yield put(searchPaymentIssueSuccess(data.data));
  } catch (error) {
    console.error('Fetch error:', error);
    yield put(searchPaymentIssueFailure(error.toString()));
  }
}

function* paymentIssuesSaga() {
  yield takeLatest(FETCH_PAYMENTISSUE_REQUEST, fetchPaymentIssues);
  yield takeLatest(SEARCH_PAYMENTISSUE_REQUEST, searchPaumentIssue)
}

export default paymentIssuesSaga;
